// Filters.jsx
import React, { useState } from 'react';
import FilterSidebar from './FilterSidebar';

const Filters = ({ onRemoveFilters, onApplyAdvancedFilters }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex items-center gap-4"> 
      {/* Remove Filters */}
      <button
        className="text-font px-3 py-2 hover:rounded-full hover:bg-bg-Gray text-sm"
        onClick={onRemoveFilters}
      >
        Clear
      </button>
      {/* Filter Button */}
      <button
        className="flex items-center gap-2 px-4 py-2 bg-white border-2 border-logo text-logo rounded-full hover:bg-logo hover:bg-logo hover:text-white transition-colors duration-300"
        onClick={() => setSidebarOpen(true)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
        Search
      </button>
      
      
      


      {/* Filter Sidebar */}
      <FilterSidebar
        isOpen={isSidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onApplyFilter={(filters) => {
          setSidebarOpen(false);
          onApplyAdvancedFilters(filters); // Pass filters to parent component
        }}
      />
      
    </div>
  );
};

export default Filters;
